import { ApplyFilterAsEvent } from '@src/common/types/empTypes';
import { useMetricBuilderStore } from '@src/emp-3.0/components/Metrics/IndividualMetric/store';
import { useFlowStore } from '@src/pages/workflow/store/flowBuilder';
export const useIsNewWorkflowPage = () => {
  const pathname = window.location.pathname;
  const regex = /^\/(app\/)?(activation\/)?workflow\/([^/]+)(\/.*)?$/;
  return regex.test(pathname);
};

export const useApplyEventDraft = (isFlowPage?: boolean) => {
  const {
    setInitialEvent,
    setCompleteEvent,
    applyErrorEvent,
    activeSectionKey,
    setActiveSectionKey,
  } = useFlowStore();

  const {
    setInitialEvent: setInitialEventForMetric,
    setCompleteEvent: setCompleteEventForMetric,
    setNumeratorEvent,
    setDenominatorEvent,
    activeSectionKey: activeSectionKeyForMetric,
    setActiveSectionKey: setActiveSectionKeyForMetric,
  } = useMetricBuilderStore();
  if (!isFlowPage) {
    return (draft: any, type: ApplyFilterAsEvent, options?) => {
      if (type === 'initial') {
        setInitialEventForMetric(draft);
      } else if (type === 'complete') {
        setCompleteEventForMetric(draft);
      } else if (type === 'numerator') {
        setNumeratorEvent(draft);
      } else if (type === 'denominator') {
        setDenominatorEvent(draft);
      }
      if (Array.isArray(activeSectionKeyForMetric)) {
        setActiveSectionKeyForMetric(activeSectionKeyForMetric.concat(['2']));
      } else {
        setActiveSectionKeyForMetric([activeSectionKeyForMetric || '', '2']);
      }
    };
  }

  return (draft: any, type: string, options?) => {
    if (type === 'initial') {
      setInitialEvent(draft);
    } else if (type === 'complete') {
      setCompleteEvent(draft);
    } else if (type === 'error') {
      if (Array.isArray(activeSectionKey)) {
        setActiveSectionKey(activeSectionKey.concat(['2']));
      } else {
        setActiveSectionKey([activeSectionKey || '', '2']);
      }

      applyErrorEvent(draft);
    }
  };
};
